module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/8b7ad5c2d9787b3a9bad1458387cfff1.png";